import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    gameSessionContainer: {
        float: "right",

        width: "70%",
    },

    scoreboardTop: {
        backgroundColor: "black",
        minHeight: "15%",
        width: "100%",
    },

    scoreboardBottom: {
        backgroundColor: "black",
        minHeight: "10%",
        width: "100%",
        justifyContent: "space-between",
    },

    videoPlayerWrapper: {
        display: "flex",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        width: "100%",
    },

    sceneTimeline: {
        backgroundColor: "black",
        color: "white",
    },

    sceneTimelineButton: {
        backgroundColor: "black",
        fontColor: "white",
    },

    contentLeft: {
        color: "white",
        float: "left",
    },

    contentRight: {
        color: "white",
        float: "right",
    },

    slowMotionButton: {
        color: "white",
        backgroundColor: "black",
        display: "block",
        "&:hover": {
            backgroundColor: "#595959",
        },
    },
}));

export { useStyles };
